import React from 'react';

import Byline from '@components/Byline';
import ArticleHeader from '@components/FeedItems/ArticleHeader';
import ArticleImage from '@components/FeedItems/ArticleImage';
import useEventTracking from '@hooks/useEventTracking';
import { Author } from '@interfaces/authors';
import { TrackingLocation } from '@tracking';

import ArticleFeedItem from '../FeedItems/ArticleFeedItem';

interface StoryItemProps {
  authors: Author[];
  id: number;
  isPro: boolean;
  picture?: string;
  publishedAt: string;
  slug: string;
  title: string;
}

const StoryItem = ({ authors, id, isPro, picture, publishedAt, slug, title }: StoryItemProps) => {
  const { Track } = useEventTracking({ location: TrackingLocation.RelatedStories });

  return (
    <Track>
      <ArticleFeedItem articleId={id} articleAuthors={authors} className="w-full flex-col">
        <ArticleImage
          className="aspect-[16/9] min-w-full leading-[0]"
          id={id}
          isPro={isPro}
          picture={picture}
          sizes="(min-width: 992px) 250px, (min-width: 480px) 600px, 300px"
          slug={slug}
          title={title}
        />
        <div className="mt-8 sm:mt-16">
          <ArticleHeader className="text-headline-xxs" title={title} slug={slug} />
          <Byline authors={authors} publishedAt={publishedAt} timeFromNow />
        </div>
      </ArticleFeedItem>
    </Track>
  );
};

export default StoryItem;
